import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const companyBusinessAreaDetailsTodo = createAsyncThunk('companyBusinessAreaDetails', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `company-business-areas/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const companyBusinessAreaDetailsSlice = createSlice({
    name: 'companyBusinessAreaDetails',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(companyBusinessAreaDetailsTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = ''
            }

        });
        builder.addCase(companyBusinessAreaDetailsTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default companyBusinessAreaDetailsSlice.reducer; 